module.exports = __webpack_public_path__ + "static/apto-306-sw-14426175d1a7296aece702810f6594f6.jpg";